/**
 * Bugün yapılanlar (v0.1.65): the day's work in a few lines, each linking to the page with the
 * detail. The API writes the lines; the panel only lays them out. Since the panel audit of
 * 25 Oct 2026 (F2) the block sits after the decisions and opens on request: the first screen
 * leads with what waits for Sercan and the business numbers, not with the activity feed.
 */

import { useId, useState } from 'react';
import type { Snapshot } from '../api/types.js';
import { Link } from '../app/router.js';
import { formatClock } from '../lib/format.js';
import { Icon } from './icons.js';
import { SectionHeader } from './primitives.js';

export function TodaySection({ snapshot, desktop = false }: { snapshot: Snapshot; desktop?: boolean }) {
  const today = snapshot.today;
  const [open, setOpen] = useState(false);
  const listId = useId();
  const lines = today.lines.length;
  return (
    <section aria-labelledby="bugun-yapilanlar" className={desktop ? 'section today today--desktop' : 'section today'}>
      <SectionHeader
        id="bugun-yapilanlar"
        title="Bugün yapılanlar"
        right={
          <span className="section-header__aside">
            <span className="mono">{formatClock(today.since)}</span> sonrası
          </span>
        }
      />
      {lines === 0 ? (
        <p className="shop-hint">Bugün henüz bir hareket yok; ilk mail ya da sipariş gelince burada görünür.</p>
      ) : (
        <>
          <button
            type="button"
            className="today__toggle"
            aria-expanded={open}
            aria-controls={open ? listId : undefined}
            onClick={() => setOpen(!open)}
          >
            {open ? 'Gizle' : `${lines} satır: ${today.lines[0]?.text ?? ''}`}
            <Icon name={open ? 'chevron-up' : 'chevron-down'} size={16} />
          </button>
          {open ? (
            <ul id={listId} className="today__lines" aria-label="Bugün yapılanlar">
              {today.lines.map((line) => (
                <li key={line.key} className={`today__line today__line--${line.key}`}>
                  <Link to={line.link} className="today__link">
                    {line.text}
                    <Icon name="chevron-right" size={16} className="today__chevron" />
                  </Link>
                </li>
              ))}
            </ul>
          ) : null}
        </>
      )}
    </section>
  );
}
